$(function () {
  let section = $('#anfitrion-planes')
  if (section.get(0) == null) {
    return
  }

  let vueApp = new Vue({
    el: section.get(0),
    data: {
      planes: planesJson,
      plan: {tipo: ''},
      isAnual: true,
    },
    mounted() {
      if(planActualId != null){
        this.plan = this.planes.find(item => item.id == planActualId)
        if(this.plan != null){
          this.isAnual = this.plan.tipo.indexOf("a") > -1
        }
      }
      if(this.plan.id == null){
        this.actualizarPlan()
      }
    },
    methods: {
      setAnual(anual){
        this.isAnual = anual
        this.actualizarPlan()
      },
      actualizarPlan(){
        if(this.isAnual){
          this.plan = this.planes.find(item => item.tipo.indexOf("a") > -1)
        }
        else{
          this.plan = this.planes.find(item => item.tipo.indexOf("m") > -1)
        }
      },
    }
  });
});
